import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Table } from 'semantic-ui-react'
import { SortIcon } from '../components'

const { Header, Body, Row, Cell, HeaderCell } = Table

const getBirthDate = (date) => {
  var m = moment('' + date);
  if (m.isValid()) {
    if (m.isAfter('1901-05-01')) { /* 2. května 1901 - Chiyo Miyako */
      return m.format('D.M.YYYY') + ' (' + moment().diff(m, 'years') + ')'
    } else {
      return '-'
    }
  } else {
    return '.'
  }
}

class AttendancesTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      field: 'lastName',
      direction: 1,
    }
    this.heading = this.heading.bind(this)
    this.changeSort = this.changeSort.bind(this)
  }

  heading(heading, text) {
    const { field, direction } = this.state
    let icon

    if (heading === field) {
      switch (direction) {
        case 1:
          icon = <SortIcon descending />
          break
        case -1:
          icon = <SortIcon ascending />
          break
        // no default
      }
    } else {
      icon = <SortIcon />
    }
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    return <a onClick={() => this.changeSort(heading)}>{text} {icon}</a>
  }

  changeSort(heading) {
    const { field, direction } = this.state
    if (field === heading) this.setState({ direction: direction * -1 })
    else this.setState({ field: heading, direction: 1 })
  }

  render() {
    let { attendees, attendance } = this.props
    const { removeAttender, viewer } = this.props
    const { field, direction } = this.state

    attendees = attendees.sort((a, b) => {
      const valueA = field !== 'birthdate' ? a.get(field) : moment(a.get(field)).valueOf()
      const valueB = field !== 'birthdate' ? b.get(field) : moment(b.get(field)).valueOf()
      let result = 0
      if (valueA < valueB) result = -1
      else if (valueA > valueB) result = 1
      return result * direction
    })

    return (
      <Table className="attendances">
        <Header>
          <Row>
            <HeaderCell>{this.heading('lastName', 'Příjmení')}</HeaderCell>
            <HeaderCell>{this.heading('firstName', 'Jméno')}</HeaderCell>
            <HeaderCell>{this.heading('birthdate', 'Datum narození')}</HeaderCell>
            <HeaderCell />
            {viewer.role !== 'FLEET_MANAGER' &&
              <HeaderCell />
            }
          </Row>
        </Header>
        <Body>
          {attendees.map((a, i) => (
            <Row key={`a._id${i}`}>
              <Cell>{a.lastName}</Cell>
              <Cell>{a.firstName}</Cell>
              <Cell>{getBirthDate(a.birthdate)}</Cell>
              <Cell><Link to={`/drivers/${a._id}/${attendance._id}`}>Zobrazit řidiče {}</Link></Cell>
              {viewer.role !== 'FLEET_MANAGER' &&
                <Cell><a onClick={() => removeAttender(a)}>Odebrat řidiče</a></Cell>
              }
            </Row>
          ))}
        </Body>
      </Table>
    )
  }
}

AttendancesTable.propTypes = {
  viewer: React.PropTypes.object.isRequired,
  attendance: React.PropTypes.object.isRequired,
  attendees: React.PropTypes.object.isRequired,
  removeAttender: React.PropTypes.func.isRequired,
}

export default AttendancesTable



// WEBPACK FOOTER //
// ./src/browser/tables/Attendees.js